import React from 'react';
import { createPortal } from 'react-dom';
import { WORKOUT_BANNER_GALLERY_URLS } from '../../../../lib/workoutBannerImage';
import { X } from '../../bravosIcons';

export type TrainerWorkoutBannerGalleryProps = {
  open: boolean;
  selectedUrl: string | null | undefined;
  onSelect: (url: string) => void;
  onClose: () => void;
};

export function TrainerWorkoutBannerGallery({
  open,
  selectedUrl,
  onSelect,
  onClose,
}: TrainerWorkoutBannerGalleryProps) {
  if (!open) return null;

  return createPortal(
    <div className="twe-portal">
      <div
        className="scrim open"
        role="dialog"
        aria-modal="true"
        aria-labelledby="twd-banner-gallery-title"
        onClick={(e) => {
          if (e.target === e.currentTarget) onClose();
        }}
      >
        <div
          className="block-modal open"
          style={{ width: 'min(520px, 90vw)' }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header">
            <h2 id="twd-banner-gallery-title" className="modal-title" style={{ margin: 0 }}>
              Workout cover
            </h2>
            <button type="button" className="drawer-close" onClick={onClose} aria-label="Close gallery">
              <X width={16} height={16} aria-hidden />
            </button>
          </div>
          <div style={{ overflowY: 'auto', padding: 12, maxHeight: '60vh' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
              {WORKOUT_BANNER_GALLERY_URLS.map((url) => {
                const selected = (selectedUrl || '').trim() === url;
                return (
                  <button
                    key={url}
                    type="button"
                    onClick={() => {
                      onSelect(url);
                      onClose();
                    }}
                    style={{
                      border: selected ? '2px solid var(--accent)' : '2px solid transparent',
                      borderRadius: 10,
                      overflow: 'hidden',
                      padding: 0,
                      cursor: 'pointer',
                    }}
                  >
                    <img src={url} alt="" style={{ display: 'block', width: '100%', aspectRatio: '4/3', objectFit: 'cover' }} loading="lazy" />
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
